import { DatatableComponent } from "@swimlane/ngx-datatable";
import { Router } from "@angular/router";
import { LoadingService } from "./../../../util/loader.service";
import { ActivatedRoute } from "@angular/router";
import { NotificacaoService } from "./notificacao.service";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Injector
} from "@angular/core";
const swal = require("sweetalert");

@Component({
  selector: "app-notificacao",
  templateUrl: "./notificacao.component.html",
  styleUrls: ["./notificacao.component.scss"]
})
export class NotificacaoComponent implements OnInit, OnDestroy {
  rows: Object[];
  selectCheck;
  selected = [];
  registroSelecao = [];
  parametroConsulta: string;
  filterState: boolean = true;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true
  };
  mesagensGrid = {
    emptyMessage: "Nenhum dado para exibir",
    totalMessage: "Total de registros",
    selectedMessage: "Selecionado"
  };
  acoesBottoes: boolean = true;
  sortDir: string = "";
  sortProp: string = "";
  @ViewChild(DatatableComponent) table: DatatableComponent;

  ngOnDestroy(): void {}

  constructor(
    public service: NotificacaoService,
    public injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    public loader: LoadingService
  ) {
    this.reloadTable();
  }

  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp).subscribe(itens => {
      this.loader.hide("body");
      this.page.count = itens.data.count;
      if (itens.data.rows.length > 0) {
        this.rows = itens.data.rows;
      } else {
        this.page.offset = 0;
        this.service.obterTodos(this.page, this.sortDir, this.sortProp).subscribe(item => {
          this.page.count = item.data.count;
          this.rows = item.data.rows;
        });
      }
    });
  }

  filtro(event) {
    this.page.descricao = this.parametroConsulta;
    this.reloadTable();
  }

  onFilterChange(eve: any) {
    this.page.ativo = eve;
    this.reloadTable();
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.registroSelecao = [];
    this.selected = [];
    this.reloadTable();
  }

  onSelect(event) {
    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

  linkNovo() {
    this.router.navigate(["/v1/notificacao/nova"]);
  }

  ngOnInit() {}

  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }
}
